var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { STATIC_ASSETS_BASE } from './constants';
var links = [
    {
        rel: 'icon',
        sizes: '196x196',
        href: 'favicons/favicon-196x196.png',
        type: 'image/png',
    },
    {
        rel: 'icon',
        sizes: '128x128',
        href: 'favicons/favicon-128x128.png',
        type: 'image/png',
    },
    {
        rel: 'icon',
        sizes: '96x96',
        href: 'favicons/favicon-96x96.png',
        type: 'image/png',
    },
    {
        rel: 'icon',
        sizes: '32x32',
        href: 'favicons/favicon-32x32.png',
        type: 'image/png',
    },
    {
        rel: 'icon',
        sizes: '16x16',
        href: 'favicons/favicon-16x16.png',
        type: 'image/png',
    },
    {
        rel: 'icon',
        sizes: '96x96',
        href: 'favicons/favicon-96x96.png',
        type: 'image/png',
    },
    {
        rel: 'apple-touch-icon-precomposed',
        sizes: '152x152',
        href: 'favicons/apple-touch-icon-152x152.png',
    },
    {
        rel: 'apple-touch-icon-precomposed',
        sizes: '144x144',
        href: 'favicons/apple-touch-icon-144x144.png',
    },
    {
        rel: 'apple-touch-icon-precomposed',
        sizes: '120x120',
        href: 'favicons/apple-touch-icon-120x120.png',
    },
    {
        rel: 'apple-touch-icon-precomposed',
        sizes: '114x114',
        href: 'favicons/apple-touch-icon-114x114.png',
    },
    {
        rel: 'apple-touch-icon-precomposed',
        sizes: '76x76',
        href: 'favicons/apple-touch-icon-76x76.png',
    },
    {
        rel: 'apple-touch-icon-precomposed',
        sizes: '72x72',
        href: 'favicons/apple-touch-icon-72x72.png',
    },
    {
        rel: 'apple-touch-icon-precomposed',
        sizes: '57x57',
        href: 'favicons/apple-touch-icon-57x57.png',
    },
    {
        rel: 'apple-touch-icon-precomposed',
        sizes: '60x60',
        href: 'favicons/apple-touch-icon-60x60.png',
    },
    {
        rel: 'apple-touch-icon',
        sizes: '180x180',
        href: 'favicons/apple-touch-icon-180x180.png',
    },
    {
        rel: 'mask-icon',
        href: 'favicons/favicon-pinned-tab.svg',
        color: '#e41421',
    },
    {
        rel: 'shortcut icon',
        href: 'favicons/favicon.ico',
    },
].map(function (link) { return (__assign(__assign({}, link), { href: "".concat(STATIC_ASSETS_BASE, "/").concat(link.href) })); });
export default links;
